// Pílula de status no estilo "Paid / Unfulfilled" da referência: fundo suave + texto colorido.
const TONES = {
  green: 'bg-emerald-50 text-emerald-700 ring-emerald-100',
  amber: 'bg-amber-50 text-amber-700 ring-amber-100',
  red: 'bg-rose-50 text-rose-600 ring-rose-100',
  violet: 'bg-accent-light text-accent ring-accent-chip',
  blue: 'bg-sky-50 text-sky-700 ring-sky-100',
  gray: 'bg-gray-50 text-gray-500 ring-gray-200',
};

export const StatusPill = ({ tone = 'gray', children, dot = false, className = '' }) => (
  <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${TONES[tone]} ${className}`}>
    {dot && <span className="h-1.5 w-1.5 rounded-full bg-current" />}
    {children}
  </span>
);
